import { Typography } from '@diritto/common/style/typography';
import { AppInstallLink, AppOsType } from '@diritto/common/system/constants';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import styled from '@emotion/styled';
import { ButtonSize } from 'constants/button';
import { useTrackingState } from 'contexts/TrackingProvider';
import { useCallback } from 'react';
import { LinkButton } from 'ui-components/common/LinkButton';
import { EventBodyContainer } from 'ui-components/layout/containers/EventBodyContainer';
import { useClient } from 'ui-hooks/useClient';
import { configure } from 'utils/configure';

export const AppInstallEventHeader = () => {
  const { tracker } = useTrackingState();
  const client = useClient();
  const appInstallUrl = client.isAosWeb ? AppInstallLink[AppOsType.Android] : AppInstallLink[AppOsType.Ios];

  const handleClick = useCallback(() => {
    tracker.track(TrackingEventType.ClickAppInstallEventHeader);
  }, [tracker]);

  return (
    <StylesEventBodyContainer>
      <StylesWrapper>
        <img alt="event" src={`${configure.staticPrefix}/images/event/event-app.png`} />
        <LinkButton
          size={ButtonSize.Large}
          buttonTypography={Typography.XSmall}
          target="_blank"
          href={appInstallUrl}
          label="앱 다운로드하기"
          onClick={handleClick}
          fullWidth
        />
      </StylesWrapper>
    </StylesEventBodyContainer>
  );
};

const StylesEventBodyContainer = styled(EventBodyContainer)`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;

const StylesWrapper = styled.div`
  width: 100%;

  & > img {
    width: 225px;
    margin-bottom: 24px;
  }
`;
